export enum RoomType {
  OFFICE = 'office',
  ROOM = 'room',
}
